// La scelta del pop di una Conversazione (tela, artboard 47): una tessera per pop, con l'avatar,
// il nome e la mansione. Di partenza il PM.
import type { AgentProfile } from '../lib/api';
import { Pop } from '../components/Pop';

export function PopChoice({
  profiles,
  value,
  onChange,
}: {
  profiles: AgentProfile[];
  value: string;
  onChange: (id: string) => void;
}) {
  return (
    <div role="radiogroup" aria-label="Chi risponde" style={{ display: 'grid', gap: 8 }}>
      <span className="t-caption dim">Chi risponde</span>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(104px, 1fr))',
          gap: 8,
          maxHeight: 236,
          overflowY: 'auto',
          padding: 2,
        }}
      >
        {profiles.map((p) => {
          const on = p.id === value;
          return (
            <button
              key={p.id}
              type="button"
              role="radio"
              aria-checked={on}
              onClick={() => onChange(p.id)}
              title={p.duty}
              style={{
                display: 'grid',
                justifyItems: 'center',
                gap: 4,
                padding: '8px 4px',
                borderRadius: 'var(--r-lg)',
                border: on ? '2px solid var(--accent)' : '1px solid var(--border)',
                background: on ? 'var(--accent-soft)' : 'var(--panel)',
                color: 'var(--text)',
                cursor: 'pointer',
                font: 'inherit',
              }}
            >
              <Pop avatar={p.avatar} size={36} />
              <span className="t-small" style={{ fontWeight: 600, textAlign: 'center' }}>
                {p.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
